import { Dimmer, Header, Loader, Segment, type SemanticCOLORS } from '@mairistem/composants';

type RelanceSummaryTileProps = {
  relancesCount: number;
  montantTotal: string;
  loading?: boolean;
  title?: string;
  subtitle?: string;
  fullWidth?: boolean;
  color?: SemanticCOLORS;
  backgroundColor?: string;
};

const RelanceSummaryTile = ({
  relancesCount,
  montantTotal,
  loading = false,
  title,
  subtitle,
  fullWidth = false,
  color = 'blue',
  backgroundColor = 'rgba(235, 242, 250, 0.5)',
}: RelanceSummaryTileProps) => (
  <Segment
    color={color}
    style={{
      padding: '1.5em',
      backgroundColor,
      textAlign: 'center',
      ...(fullWidth
        ? { marginBottom: '1.5em', width: '100%' }
        : { margin: '0 auto 1.5em auto', maxWidth: 425 }),
    }}
  >
    <Dimmer active={loading} inverted>
      <Loader inverted />
    </Dimmer>

    {!loading && (
      <>
        <Header as="h3" style={{ margin: '0 0 0.5em 0' }}>
          <Header.Content>
            {title || (
              <>
                {relancesCount <= 1 ? '1' : relancesCount}{' '}
                {relancesCount <= 1 ? 'relance sera générée' : 'relances seront générées'}
              </>
            )}
          </Header.Content>
        </Header>

        <Header as="h3" style={{ margin: 0 }}>
          <Header.Content>{subtitle || <>pour un montant de {montantTotal}</>}</Header.Content>
        </Header>
      </>
    )}
  </Segment>
);

export default RelanceSummaryTile;
